import React from 'react';
import { ChatWidgetConversation } from './ChatWidgetConversation';
import { mockMessages } from '../../__fixtures__/conversations';
const noop = Function.prototype;
const meta = {
    title: 'Features/AIChatWidget/ChatWidgetConversation',
    component: ChatWidgetConversation,
    decorators: [
        (Story) => (React.createElement("div", { style: { height: 600, width: 500, border: '1px solid #e5e7eb' } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const EmptyState = {
    args: {
        messages: [],
        onSendMessage: noop,
        onSelectPrompt: noop,
        userName: 'John'
    }
};
export const WithMessages = {
    args: {
        messages: mockMessages,
        onSendMessage: noop,
        onSelectPrompt: noop,
        isStreaming: false
    }
};
export const Streaming = {
    args: {
        messages: mockMessages,
        onSendMessage: noop,
        onSelectPrompt: noop,
        isStreaming: true
    }
};
